import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { BeneficiaireModalDetailFormationComponent } from '../modal/beneficiaire-modal-detail-formation/beneficiaire-modal-detail-formation.component';
import { Employee } from 'src/app/shared/models/employee/employee';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Prestation, PrestationStatutString, PrestationTypeString } from 'src/app/shared/models/prestation';
import { DataStorageService } from 'src/app/core/services/dataStorage/data-storage.service';
import { ConstantsService } from 'src/app/core/services/constant/constants.service';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-detail-beneficiaire',
	templateUrl: './detail-beneficiaire.component.html',
	styleUrls: ['./detail-beneficiaire.component.scss']
})
export class DetailBeneficiaireComponent implements OnInit {
	beneficiaire: Beneficiaire;
	confirmDeleteModalRef: BsModalRef;
	detailFormationModalRef: BsModalRef;
	competences;
	isDeletable = true;

	labelBeneficiaireCapitalized: string;
	labelIntervenantCapitalizedPluralized: string;
	labelIntervenantCapitalized: string;
	labelInterventionPluralizedCapitalized: string;

	isFormReadOnly = true;
	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: false };

	public PrestationTypeStringEnum = PrestationTypeString;
	public PrestationStatutStringEnum = PrestationStatutString;
	listPrestation : Prestation[];

	/**
	 * Index de pagination de la liste des formations d'un beneficiaire
	 */
	currentPage: number;

	/**
	 * Attribut sur lequel trier
	 */
	sortType = 'date';

	/**
	 * Ordre de tri
	 */
	sortOrder: SortOrder = 'asc';


	listEmployee: Employee[] = [];

	MAX_NAME_CHAR = 25;
	NAME_PATTERN =
		"^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";
	form = this.fb.group({
		firstName: new FormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.maxLength(this.MAX_NAME_CHAR),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		lastName: new FormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.maxLength(this.MAX_NAME_CHAR),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		address: new FormControl(new Address().label, [
			// Validators.maxLength(60)
		]),
		
		birthDate: new FormControl<Date>(null),
		telephone: new FormControl('', Validators.pattern('0{1}[0-9]{9}')),
		email: new FormControl('', Validators.email),
		genre: new FormControl(''),
		handicapPrincipal: new FormControl(''),
		modeCommunication: new FormControl(''),
		degreSurdite: new FormControl(''),
		tauxReconnaissance: new FormControl(),
		niveauEtude: new FormControl(),
		niveauQualification: new FormControl(),
		statutProfessionnel: new FormControl(),
		//eligibiliteBeneficiaire: new FormControl(),
		//situationFamiliale: new FormControl(),
		origineHandicap: new FormControl(''),
		doleances: new FormControl(''),
		rapportHandicap: new FormControl(''),
		environnementSocial: new FormControl(''),
		diplomes: this.fb.array([this.fb.group({
			etablissement: '',
			annee: '',
			amenagement: '',
			niveauEtude: ''
		})]),
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService,
		private cacheService: CacheService,
		private toastService: ToastService,
		private fb: FormBuilder,
		private dataStorageService: DataStorageService,
		private appConstants: ConstantsService
	) {}

	ngOnInit(): void {
		this.cacheService.clearCache();

		/**
		 * Récupère le paramètre de la route
		 */
		const id = +this.route.snapshot.paramMap.get('id');
		/**
		 * Appel le back pour récupérer l'beneficiaire grâce à son id
		 */
		this.facade.beneficiaireService.getBeneficiaireById(id).subscribe({
			next: (beneficiaire: Beneficiaire) => {
				console.log(beneficiaire);
				this.beneficiaire = beneficiaire;
				if (this.beneficiaire.address && this.beneficiaire.address.label) {
					this.isAddressDefault.value = true;
				}
				this.facade.prestationService
					.getPrestationByBeneficiaire(this.beneficiaire.id)
					.subscribe((data) => {
						this.listPrestation = data;
					});
			},
			error: (err: ErrorResponse) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.goBack();
			}
		});
	}

	goBack(): void {
		this.router.navigate(['/beneficiaires/list']);
	}

	goEdit(beneficiaire: Beneficiaire): void {
		const link = ['/beneficiaires/edit', beneficiaire.id];
		this.router.navigate(link);
	}

	delete(beneficiaire: Beneficiaire): void {
		if (this.isDeletable ) {
			if(beneficiaire.typeHandicaps?.length>1){
				for (let typeHandicap of this.beneficiaire.typeHandicaps) {
					if (typeHandicap.id === this.facade.dataStorageService.getService()?.typeHandicap.id) {
						this.beneficiaire.typeHandicaps.splice(this.beneficiaire.typeHandicaps.indexOf(typeHandicap), 1);
						break;
					}
				}
				this.facade.beneficiaireService
				.updateBeneficiaire(this.beneficiaire)
				.subscribe({
					complete: () => {
						this.modalService.hide();
						this.goBack();
					}
				})
			}else{
				// this.facade.authenticationService.authenticateIsy(this.appConstants.loginIsy, this.appConstants.passwordIsy).subscribe({
				// 	next: (val) => {
				// 		this.dataStorageService.setTokenIsy(val.token);
				// 		console.log(val);
				// 		this.facade.beneficiaireService.deleteBeneficiaireIsy(this.beneficiaire.id).subscribe({
				// 			next : (val) => {
				// 				console.log(val);
				// 			}
				// 		});
				// 	}
						
				// })
				this.facade.beneficiaireService
					.deleteBeneficiaire(beneficiaire.id)
					.subscribe({
						complete: () => {
							this.modalService.hide();
							this.goBack();
						},
						error: (err: ErrorResponse) => {
							this.isValidateButtonClicked.value = false;
							this.toastService.createHttpErrorToast(
								err.error.message,
								err.status
							);
						}
				});
			}
		}
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	openModalDetailFormation(formation: MissionRequest): void {
		const initialState = {
			missionRequest: formation,
			beneficiaire: this.beneficiaire
		};
		this.detailFormationModalRef = this.modalService.show(
			BeneficiaireModalDetailFormationComponent,
			{
				class: 'custom-modal-side',
				initialState
			}
		);
	}

	editForm(): void {
		this.isFormReadOnly = false;
	}

	stopEditForm(): void {
		this.form.reset();

		if (
			this.beneficiaire.address &&
			this.beneficiaire.address.label &&
			this.beneficiaire.address.latitude &&
			this.beneficiaire.address.longitude
		) {
			this.isAddressDefault.value = true;
		}
		this.isAddressSelected.value = false;
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;
	}

	onSubmit() {
		if (this.form.valid) {
			this.isValidateButtonClicked.value = true;
			this.facade.beneficiaireService
				.updateBeneficiaire(this.beneficiaire)
				.subscribe({
					next: () => {
						// this.facade.authenticationService.authenticateIsy(this.appConstants.loginIsy, this.appConstants.passwordIsy).subscribe({
						// 	next: (val) => {
						// 		this.dataStorageService.setTokenIsy(val.token);
						// 		console.log(val);
						// 		this.facade.beneficiaireService.updateBeneficiaireIsy(this.beneficiaire).subscribe({
						// 			next : (val) => {
										this.isValidateButtonClicked.value = false;
										this.reload();
						// 			}
						// 		});
						// 	}
								
						// })
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
		}
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}

	calculateConsumedHours(selectedPrestation : number){
		let listActivite;
		let totalHeuresActivites = 0;
		this.facade.activitePrestationService.getByPrestation(selectedPrestation).subscribe({
			next: (val) => {
				listActivite = val;
			}
		});

		listActivite?.forEach((activite) => {
			totalHeuresActivites += activite.chargeTravail;
		})
		return totalHeuresActivites
	}
}
